import api from './api';

class SettingGrabFoodService {
  getGrabFoodBranches() {
    return api.get('/merchant/grab/stores');
  }

  getChannels() {
    return api.get('/merchant/grab/channels');
  }

  createJourney(branchCode) {
    return api.post('/merchant/grab/create-journey', { branch_code: branchCode });
  }

  // Grab orders ON (1) / OFF (0) for a sales channel.
  setStoreStatus(branchId, status) {
    return api.post('/merchant/grab/store-status', { branch_id: branchId, status });
  }

  syncMenu(grabStoreId) {
    return api.post('/merchant/grab/sync-menu', { grab_store_id: grabStoreId });
  }

  checkMenuPrice(branchId, priceKey) {
    return api.post('/merchant/grab/check-menu-price', {
      branch_id: branchId,
      price_key: priceKey,
    });
  }
}

export default new SettingGrabFoodService();
